import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'flyIsFutureDate'
})
export class IsFutureDatePipe implements PipeTransform {
  transform(value: string | null): boolean {
    if (value == null) {
      return false;
    }

    const startDate = new Date(value);
    const currentDate = new Date();

    return startDate > currentDate;
  }
}
